var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
export var CloseIcon = function (_a) {
    var color = _a.color;
    return (_jsx("svg", __assign({ width: "11", height: "11", viewBox: "0 0 11 11", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, { children: _jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M9.98477 9.98447C10.4054 9.56388 10.4054 8.88199 9.98477 8.4614L7.02338 5.50001L9.9813 2.54209L10.0777 2.43181C10.399 2.00968 10.3668 1.40456 9.9813 1.01903C9.56072 0.598449 8.87882 0.598449 8.45824 1.01903L5.50032 3.97695L2.53869 1.01533L2.42841 0.918943C2.00628 0.597665 1.40116 0.629793 1.01563 1.01533C0.59505 1.43591 0.59505 2.11781 1.01563 2.53839L3.97726 5.50001L1.01925 8.45802L0.922863 8.56831C0.601585 8.99044 0.633713 9.59555 1.01925 9.98109C1.43983 10.4017 2.12173 10.4017 2.54231 9.98109L5.50032 7.02308L8.46171 9.98446L8.572 10.0808C8.99412 10.4021 9.59924 10.37 9.98477 9.98447Z", fill: color }, void 0) }), void 0));
};
